const ListIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='128'
    height='106'
    viewBox='0 0 128 106'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.7025 79.3228C17.2927 74.8833 8.49711 76.4807 4.05759 82.891C-0.381921 89.3012 1.21546 98.0968 7.62574 102.536C14.0356 106.976 22.8312 105.378 27.2707 98.9678C31.7102 92.5579 30.1128 83.7623 23.7025 79.3228ZM45.3485 102.102H126.976V82.4378H45.3485V102.102ZM24.0576 41.8143C17.6478 37.3744 8.85222 38.9722 4.41271 45.3825C-0.0268093 51.7923 1.57057 60.5879 7.98043 65.0274C14.3907 69.4669 23.1863 67.8695 27.6258 61.4593C32.0653 55.0494 30.4679 46.2538 24.0576 41.8143ZM126.907 42.2766L42.7959 43.859L43.1713 63.7897L127.281 62.2073L126.907 42.2766ZM6.79964 26.5778C13.2099 31.0173 22.0055 29.4199 26.445 23.01C30.8845 16.5998 29.2871 7.80421 22.8768 3.3647C16.467 -1.07482 7.67142 0.522561 3.23191 6.93284C-1.20761 13.3431 0.389771 22.1383 6.79964 26.5778ZM42.9874 25.6059H125.441V5.10246H42.9874V25.6059Z'
      fill='currentColor'
    />
  </svg>
);

export default ListIcon;
